import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { RepFilterProvider } from "@/context/RepFilterContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import AppShell from "@/components/AppShell";

import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import RenewLicense from "@/pages/RenewLicense";
import AcknowledgeRisk from "@/pages/AcknowledgeRisk";
import Planning from "@/pages/Planning";
import ChangePassword from "@/pages/ChangePassword";
import Dashboard from "@/pages/Dashboard";
import Facilities from "@/pages/Facilities";
import FacilityDetail from "@/pages/FacilityDetail";
import Visits from "@/pages/Visits";
import FollowUps from "@/pages/FollowUps";
import SWOTs from "@/pages/SWOTs";
import Owners from "@/pages/Owners";
import UsersPage from "@/pages/Users";
import Tasks from "@/pages/Tasks";
import Providers from "@/pages/Providers";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/renew-license" element={<RenewLicense />} />
      <Route path="/acknowledge-risk" element={<AcknowledgeRisk />} />
      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/facilities" element={<Facilities />} />
        <Route path="/facilities/:id" element={<FacilityDetail />} />
        <Route path="/visits" element={<Visits />} />
        <Route path="/planning" element={<Planning />} />
        <Route path="/followups" element={<FollowUps />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/providers" element={<Providers />} />
        <Route path="/swots" element={<SWOTs />} />
        <Route path="/owners" element={<Owners />} />
        <Route path="/owners/:id" element={<Owners />} />
        <Route path="/settings/password" element={<ChangePassword />} />
        <Route path="/users" element={<ProtectedRoute adminOnly><UsersPage /></ProtectedRoute>} />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <RepFilterProvider>
            <BrowserRouter>
              <AppRouter />
            </BrowserRouter>
            <Toaster richColors position="top-right" />
          </RepFilterProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
